module.exports = __webpack_public_path__ + "static/project-ares-logo-aaf3acf3e46b456f725846d13ccd4473.svg";